<template>
  <div style="overflow: auto">
    <div id="app">
      <v-app>
        <Notifier></Notifier>
        <router-view></router-view>
      </v-app>
    </div>
  </div>
</template>

<script>
import Notifier from './components/Notifier'
import { mapState } from "vuex"
// import { controllerName, mainSite } from "./store/constants"

export default {
  name: 'app',
  components: {
    Notifier
  },
  computed: {
    ...mapState({
      // userToken: state => state.Auth.auth.token
    })
  },
  beforeCreate(){
    // Below is for initial LINE LIFF with LIFF ID
    // this.$liff.init(function (data) {});
    // console.log("DEBUG beforeCreate : init line liff");
    // this.$liff.init({liffId: '1656378176-VRw6EZwe'}).catch(function (error){
    //             alert('Error init liff: '+error);
    //         })
  },
  created () {
    this.$store.commit('General/clearAllNoti')
    // this.$lc.callApex(`${controllerName}.getSession`, (res, event) => {
    //   if (res === 200) {
        this.$router.push({ name: 'Home', query: this.$route.query })
    //   } else {
    //     window.location = mainSite
    //   }
    // })
    // if (!this.userToken) {
    //   if (this.$route.name !== 'Login') {
    //     this.$router.push({ name: 'Login' })
    //   }
    // } else {
      // needed to assign route on salesforce
    // }
  }
}
</script>

<style>

#app {
  font-family: 'Prompt', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-width: var(--min-screen-width);
}

</style>
